import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Check, ChevronRight } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const steps = [
  { id: 1, name: 'Company', path: '/onboarding/company' },
  { id: 2, name: 'Drivers', path: '/onboarding/drivers' },
  { id: 3, name: 'CashX', path: '/onboarding/cashx' },
  { id: 4, name: 'QR Test', path: '/onboarding/qr-test' },
  { id: 5, name: 'Complete', path: '/onboarding/done' }
];

const OnboardingLayout = ({ children, currentStep }) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    loadStatus();
  }, []);

  const loadStatus = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/onboarding/status`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStatus(response.data);
    } catch (error) {
      console.error('Load status error:', error);
    }
  };

  const canAccessStep = (stepId) => {
    if (!status) return stepId === 1;
    return stepId <= (status.onboarding_step + 1);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b">
        <div className="max-w-6xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold">Flotto Setup</h1>
              <p className="text-sm text-gray-500">Get your fleet management system ready</p>
            </div>
            <Button variant="ghost" onClick={() => navigate('/dashboard')}>
              Exit Setup
            </Button>
          </div>
        </div>
      </div>

      {/* Stepper */}
      <div className="bg-white border-b">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            {steps.map((step, idx) => (
              <div key={step.id} className="flex items-center">
                <div
                  className={`flex items-center gap-2 cursor-pointer ${
                    canAccessStep(step.id) ? 'opacity-100' : 'opacity-40 cursor-not-allowed'
                  }`}
                  onClick={() => canAccessStep(step.id) && navigate(step.path)}
                >
                  <div
                    className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold ${
                      currentStep === step.id
                        ? 'bg-blue-600 text-white'
                        : currentStep > step.id
                        ? 'bg-green-600 text-white'
                        : 'bg-gray-200 text-gray-600'
                    }`}
                  >
                    {currentStep > step.id ? <Check className="h-5 w-5" /> : step.id}
                  </div>
                  <span className="text-sm font-medium hidden md:block">{step.name}</span>
                </div>
                {idx < steps.length - 1 && (
                  <ChevronRight className="h-5 w-5 mx-4 text-gray-400" />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-8">
        <Card className="p-8">{children}</Card>
      </div>
    </div>
  );
};

export default OnboardingLayout;
